import styled, { keyframes, css } from "styled-components";
import { device } from "./Device";
import pinkHeader from "../assets/images/pink-rect-header.png";

export const PageWrapper = styled.div`
  position: relative;
  height: 100vh;
  width: 100vw;
  padding-bottom: 3vh;
  box-sizing: border-box;
`;

//NavBar.js
export const NavWrapper = styled.nav`
  position: relative;
  z-index: 10;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  padding: 2vh 3vw;
  gap: 1vw;
`;

export const NavLinksWrapper = styled.div`
  flex: 1;
  align-items: center;
  justify-content: space-around;

  background-image: url(${pinkHeader});
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center;
  box-sizing: border-box;

  @media ${device.mobileS} {
    display: none;
  }

  @media ${device.laptop} {
    display: flex;

    min-height: 6vh;
    padding: 2.5vh 2vw;
    max-width: 70vw;
  }

  @media ${device.laptopL} {
    display: flex;

    min-height: 6vh;
    padding: 3.5svh 2vw;
    max-width: 70vw;
  }

  @media ${device.desktop} {
    display: flex;

    min-height: 6vh;
    padding: 4vh 2vw;
    max-width: 70vw;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  letter-spacing: 0.1vw;

  img {
    width: 100%;
    height: auto;
  }

  @media ${device.mobileS} {
    width: 30vw;
    font-size: 2.25vh;
    gap: 0.5vh;
  }

  @media ${device.mobileM} {
    width: 32vw;
    font-size: 2.15vh;
  }

  @media ${device.mobileL} {
    width: 32vw;
  }

  @media ${device.tablet} {
    width: 30vw;
    font-size: 2.7vh;
    gap: 0.8vh;
  }

  @media ${device.laptop} {
    width: 15vw;
    font-size: 2.5vh;
  }

  @media ${device.laptopL} {
    width: 15vw;
  }

  @media ${device.desktop} {
    width: 15vw;
    font-size: 2.6vh;
  }
`;

export const MobileMenuWrapper = styled.div`
  @media ${device.mobileS} {
    position: relative;
    display: flex;
    flex-direction: column;
  }

  @media ${device.laptop} {
    display: none;
  }
`;

const shake = keyframes`
  0% { transform: rotate(0deg); }
  25% { transform: rotate(5deg); }
  50% { transform: rotate(0deg); }
  75% { transform: rotate(-5deg); }
  100% { transform: rotate(0deg); }
`;

export const MobileNavRect = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  filter: drop-shadow(0 0.5vh 0.8vh rgba(0, 0, 0, 0.5));
  cursor: pointer;

  transform: ${(props) => (props.$isOpen ? props.$translate : "none")};
  transition: transform 1s cubic-bezier(0.33, 1, 0.68, 1);

  &:nth-child(1) {
    z-index: 1;
  }

  &:nth-child(2) {
    z-index: 2;
  }

  &:nth-child(3) {
    z-index: 3;
  }

  a {
    background-image: url(${(props) => props.$bgImage});
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;

    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;

    color: ${(props) => (props.$isOpen || props.$isOnTop ? "white" : "transparent")};
    text-decoration: none;
    font-weight: 700;
    letter-spacing: 0.15vw;
    margin: 0;
    pointer-events: ${(props) => (props.$isOpen ? "auto" : "none")};
    transition: color 1s cubic-bezier(0.33, 1, 0.68, 1);

    animation: ${(props) =>
      props.$isOpen
        ? "none"
        : css`
            ${shake} 1s infinite
          `};
  }

  @media ${device.mobileS} {
    width: 22vw;
    height: 6.5vh;

    a {
      font-weight: 500;
      font-size: 2vh;
    }

    &:nth-child(1) {
      margin-top: 1vh;
    }

    &:nth-child(2) {
      margin-top: -5vh;
    }

    &:nth-child(3) {
      margin-top: -5vh;
    }
  }

  @media ${device.mobileM} {
    width: 22vw;
    height: 6.5vh;

    a {
      font-size: 1.9vh;
    }
  }

  @media ${device.mobileL} {
    width: 23vw;
    height: 6.5vh;

    a {
      font-size: 1.8vh;
      font-weight: 500;
    }
  }

  @media ${device.tablet} {
    width: 20vw;
    height: 7vh;

    a {
      font-size: 2.2vh;
      font-weight: 500;
    }
  }
`;

//Footer.js
const tickerAnimation = keyframes`
0% {transform: translateX(0);}
100% {transform: translateX(-50%);}`;

export const TickerInner = styled.div`
  display: inline-flex;
  animation: ${tickerAnimation} 50s linear infinite;
`;

//Hero.js
export const ContentWrapper = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;

  @media ${device.mobileS} {
    max-width: 100%;
    padding: 4vh 5vh 3vh;
    margin-left: 0;
    align-items: flex-start;
    gap: 2.6vh;
  }

  @media ${device.mobileL} {
    gap: 2.9vh;
  }

  @media ${device.tablet} {
    max-width: 100%;
    padding: 4vh 6vh 3vh;
    gap: 3.5vh;
  }

  @media ${device.laptop} {
    padding: 4vh 4vw 7.5vh 0;
    align-items: flex-end;
    max-width: 70%;
    margin-left: auto;
  }

  @media ${device.laptopL} {
    padding: 2vh 4vw 7.5vh 0;
    max-width: 60%;
    gap: 2vh;
  }

  @media ${device.desktop} {
    padding: 2vh 4vw 7.5vh 0;
  }
`;

export const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media ${device.mobileS} {
    padding-left: 0;
    gap: 2vh;
    max-width: 80%;

    align-self: flex-end;
    align-items: flex-end;
  }

  @media ${device.tablet} {
    padding-left: 0;
    max-width: 70%;

    align-self: flex-end;
    align-items: flex-end;
  }

  @media ${device.laptop} {
    padding-left: 5vw;
    padding-top: 3vh;
    max-width: 48vw;
    align-items: flex-end;
  }

  @media ${device.laptopL} {
    padding-left: 5vw;
    padding-top: 3vh;
    max-width: 45vw;
  }

  @media ${device.desktop} {
    padding-left: 5vw;
    padding-top: 3vh;
    max-width: 45vw;
  }
`;

export const MeetupWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 70%;
  gap: 0.5vw;

  @media ${device.laptop} {
    display: none;
  }
`;

export const MeetupAndVisitWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  align-items: center;

  @media ${device.mobileS} {
    margin-top: 12vh;
  }

  @media ${device.mobileM} {
    margin-top: 11vh;
  }

  @media ${device.mobileL} {
    margin-top: 14vh;
  }

  @media ${device.tablet} {
    margin-top: 8vh;
  }

  @media ${device.laptop} {
    margin-top: 0;
  }
`;
